export default "__VITE_ASSET__CqKpu3Ea__"